import { Component, Input } from '@angular/core';

@Component({
    selector: 'pallet-loading-indicator',
    templateUrl: './pallet-loading-indicator.component.html',
    styleUrls: ['./pallet-loading-indicator.component.scss']
})
export class PalletLoadingIndicatorComponent {
    @Input() size: 'sm' | 'md' | 'lg' = 'md';
    @Input() showLabel = false;
    @Input() color: 'gray' | 'dark-gray' | 'full' = 'gray';
    @Input() centered = false;
}
